/**
 * Form (conteúdo de slide-over) para emitir Carta de Correção (CC-e) — redesign FIN-9.
 *
 * Regras SEFAZ (validadas no backend M6.B.1): NF-e EMITIDA, tipo NFE, dentro
 * de 30 dias, sequencial único 1-20, texto >= 15 chars. NÃO corrige valor,
 * base de cálculo, alíquota, CNPJ do destinatário nem data de emissão.
 */
import React, { useState } from "react";
import { FiEdit3 } from "react-icons/fi";

import AsyncButton from "../../../components/AsyncButton";
import { useAuth } from "../../../context/AuthContext";
import { emitirCartaCorrecao } from "../../../services/fiscal";
import { Input, Textarea } from "../../Orcamentos/styles";

export default function EmitirCceForm({ notaId, sequencialSugerido, onEmitted, onCancel }) {
  const { request } = useAuth();
  const [texto, setTexto] = useState("");
  const [sequencial, setSequencial] = useState("");

  const okTexto = texto.trim().length >= 15;

  const submit = async () => {
    let seq = null;
    if (sequencial) {
      seq = parseInt(sequencial, 10);
      if (isNaN(seq) || seq < 1 || seq > 20) throw new Error("Sequencial deve estar entre 1 e 20.");
    }
    const cce = await emitirCartaCorrecao(request, notaId, texto.trim(), seq);
    onEmitted?.(cce);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
      <div style={{
        padding: "10px 12px", background: "var(--warning-bg)",
        border: "1px solid var(--warning-border)", borderRadius: 8, fontSize: 12.5,
        color: "var(--ink-2)", lineHeight: 1.5,
      }}>
        <strong>Pode corrigir:</strong> razão social/endereço do destinatário, NCM/descrição
        do produto, data de saída, nº do pedido, peso.
        <br />
        <strong style={{ color: "var(--danger-text)" }}>Não pode via CC-e:</strong> valor,
        base de cálculo, alíquota, CNPJ do destinatário, data de emissão — para esses,
        cancele a NF-e (24h) e emita uma nova.
      </div>

      <label style={{ display: "flex", flexDirection: "column", gap: 4 }}>
        <span style={{ fontSize: 12, fontWeight: 600 }}>Texto da correção *</span>
        <Textarea value={texto} rows={6} maxLength={1000}
                  onChange={(e) => setTexto(e.target.value)}
                  placeholder="Descreva a correção de forma clara. Ex.: 'Onde se lê ABC LTDA, leia-se ABCD LTDA — erro de digitação.'" />
        <span className={"char-count" + (okTexto ? " ok" : "")}>{texto.trim().length}/15 mín · 1000 máx</span>
      </label>

      <label style={{ display: "flex", flexDirection: "column", gap: 4 }}>
        <span style={{ fontSize: 12, fontWeight: 600 }}>Sequencial (opcional)</span>
        <Input type="number" min="1" max="20" value={sequencial}
               onChange={(e) => setSequencial(e.target.value)}
               placeholder={`vazio = automático (${sequencialSugerido || 1})`} />
        <span style={{ fontSize: 11, opacity: 0.6 }}>
          A NF-e aceita até 20 CC-e, cada uma com sequencial único (1–20).
        </span>
      </label>

      <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
        <button type="button" className="btn btn--secondary" onClick={onCancel}>Cancelar</button>
        <AsyncButton variant="primary" disabled={!okTexto}
                     successMessage="CC-e emitida"
                     onClick={submit}>
          <FiEdit3 size={14} aria-hidden="true" /> Emitir CC-e
        </AsyncButton>
      </div>
    </div>
  );
}
